import { baseApi } from '@shared/api'
import { AsanRefuceRequest, AsanSignRequest, AsanSignResponse } from './types'

const signApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchAsanSign: builder.mutation<AsanSignResponse, AsanSignRequest>({
      query: (args) => ({
        url: '/ib/signing/asan/sign',
        data: args,
        method: 'POST',
        skipGlobalError: true,
      }),
    }),
    fetchRefusedSign: builder.mutation<any, AsanRefuceRequest>({
      query: (data) => ({
        url: '/ib/signing/asan/refuce',
        data,
        method: 'POST',
        skipGlobalError: true,
      }),
    }),
  }),
})

export const { useFetchAsanSignMutation, useFetchRefusedSignMutation } = signApi
